<template>
    <div>
        <v-toolbar color="primary darken-1" fixed dark app>
            <v-toolbar-title>
                <v-toolbar-side-icon medium @click="handleDrawerToggle"></v-toolbar-side-icon>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn icon @click="handleFullScreen()">
                    <v-icon medium>fa fa-expand</v-icon>
                </v-btn>

                <!--seccion de notificaciones-->
                <!--<v-menu
                    offset-y
                    origin="center center"
                    :nudge-bottom="14"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    ref="notificacionesMenu"
                >
                    <v-btn icon flat slot="activator">
                        <v-badge color="red" overlap>
                            <span v-if="USER_UNREAD_NOTIFICACIONES.length" slot="badge">{{
                                USER_UNREAD_NOTIFICACIONES.length < 10 ? USER_UNREAD_NOTIFICACIONES.length : "+9"
                            }}</span>
                            <v-icon medium>{{ LOAD_UNREAD_NOTIFICACIONES ? "fa-bell" : "fa-bell-slash" }}</v-icon>
                        </v-badge>
                    </v-btn>
                    <notification-list @menuCanceled="cancelNotificacionesMenu()"></notification-list>
                </v-menu>-->

                <!--seccion de usuario-->
                <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
                    <v-btn icon flat slot="activator">
                        <v-icon medium>fa fa-user</v-icon>
                    </v-btn>
                    <v-list class="pa-0">
                        <v-list-tile
                            v-for="(item, index) in items"
                            :to="!item.href ? { name: item.name } : null"
                            :href="item.href"
                            @click="item.click"
                            ripple="ripple"
                            :disabled="item.disabled"
                            :target="item.target"
                            rel="noopener"
                            :key="index"
                        >
                            <v-list-tile-action v-if="item.icon">
                                <v-icon medium>{{ item.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <auth-user v-if="showAuthUser" :details-item="CURRENT_USER" @detailsCanceled="closeProfile"> </auth-user>
    </div>
</template>

<script>
import Util from "@/util"
import { mapGetters } from "vuex"
const NotificationList = () =>
    import(/* webpackChunkName: "notificacion-list" */ "@/components/widgets/list/NotificationList")
const AuthUser = () => import("@/components/auth-user/auth-user")

export default {
    name: "AppToolbar",
    components: {
        NotificationList,
        AuthUser
    },
    data() {
        return {
            showAuthUser: false
        }
    },
    computed: {
        ...mapGetters(["CURRENT_USER", "USER_UNREAD_NOTIFICACIONES", "LOAD_UNREAD_NOTIFICACIONES"]),

        items() {
            return [
                {
                    icon: "fa-user",
                    href: "#",
                    title: this.CURRENT_USER ? this.CURRENT_USER.username : "",
                    click: this.handleProfile
                },
                {
                    icon: "fa fa-power-off",
                    href: "#",
                    title: "Cerrar sesión",
                    click: this.handleLogut
                }
            ]
        }
    },

    methods: {
        handleDrawerToggle() {
            this.$emit("side-icon-click")
        },
        handleFullScreen() {
            Util.toggleFullScreen()
        },
        handleLogut() {
            //handle logout
            this.$store.dispatch("LOGOUT").then(() => {
                this.$router.push("/login")
            })
        },
        handleProfile() {
            this.showAuthUser = true
        },

        closeProfile() {
            this.showAuthUser = false
        },

        cancelNotificacionesMenu() {
            //cerrar el menu cuando se de click en el boton de ver todas las notificaciones
            this.$refs.notificacionesMenu.isActive = false
        }
    }
}
</script>

<style lang="stylus" scoped></style>
